module.exports = __webpack_public_path__ + "fonts/s2l.2e0fa56.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/s2l.eot?1k5k71
// module id = 279
// module chunks = 0